module.exports = __webpack_public_path__ + "img/logo.a493e78a.png";